export const business_info = "name_and_category";
export const poc_info = "poc_info";
export const app_name = "application_name";
export const default_service = "default_service";
